"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePortfolioContentTranslation = void 0;
const client_1 = require("@apollo/client");
const react_1 = require("@apollo/client/react");
const typings_1 = require("../../typings");
const ENGLISH_LANGUAGE_CODE = 'en';
const GET_CONTENT_TRANSLATIONS = (0, client_1.gql) `
  query getContentTranslationsByIds(
    $documentIds: [String!]!
    $softwareIds: [String!]!
    $visualIds: [String!]!
  ) {
    documentsById(ids: $documentIds) {
      id
      title
    }
    softwareById(ids: $softwareIds) {
      id
      title
    }
    visualsById(ids: $visualIds) {
      id
      title
    }
  }
`;
const usePortfolioContentTranslation = (selectedTabKey, ids, language) => {
    const { data, loading } = (0, react_1.useQuery)(GET_CONTENT_TRANSLATIONS, {
        variables: {
            documentIds: selectedTabKey === typings_1.SearchResultTabKeyEnum.Documents ? ids : [],
            softwareIds: selectedTabKey === typings_1.SearchResultTabKeyEnum.Downloads ? ids : [],
            visualIds: selectedTabKey === typings_1.SearchResultTabKeyEnum.Drawings ? ids : [],
        },
        skip: language === ENGLISH_LANGUAGE_CODE || !selectedTabKey || !ids,
    });
    return { translations: data || {}, isContentTranslationLoading: loading };
};
exports.usePortfolioContentTranslation = usePortfolioContentTranslation;
